'use client';

import { createFileRoute, Navigate } from '@tanstack/react-router';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/facilities/dashboard')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.facilityEmissionsDashboard'),
  }),
  component: () => <Navigate to="/ghg/emissions" replace />,
});
